export default "__VITE_ASSET__Cj1bwVFQ__"